import React from 'react';
import { getThemeColors, BRAND, BRAND_LIGHT } from '../../lib/theme';
import { Icon } from '../icons';

export interface MultiSelectOption {
  id: number;
  label: string;
}

interface MultiSelectProps {
  dark?: boolean;
  options: MultiSelectOption[];
  value: number[];
  onChange: (next: number[]) => void;
  /** Platzhalter der Auswahl zum Hinzufügen. */
  placeholder: string;
  ariaLabel: string;
  /** Beschriftung des Entfernen-Knopfs je Chip (mit {{name}} ersetzt vom Aufrufer). */
  removeLabel: (name: string) => string;
}

/** Mehrfachauswahl: gewählte Einträge als Chips mit Entfernen-Knopf, Hinzufügen per Auswahlliste. */
export function MultiSelect({ dark = false, options, value, onChange, placeholder, ariaLabel, removeLabel }: MultiSelectProps) {
  const t = getThemeColors(dark);
  const selected = value
    .map(id => options.find(o => o.id === id))
    .filter((o): o is MultiSelectOption => !!o);
  const available = options.filter(o => !value.includes(o.id));

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, alignItems: 'center' }}>
      {selected.map(o => (
        <span
          key={o.id}
          data-testid={`chip-${o.id}`}
          style={{
            display: 'inline-flex', alignItems: 'center', gap: 6,
            background: BRAND_LIGHT, color: BRAND, borderRadius: 9999,
            padding: '3px 6px 3px 10px', fontSize: 12, fontWeight: 500,
          }}
        >
          {o.label}
          <button
            type="button"
            aria-label={removeLabel(o.label)}
            onClick={() => onChange(value.filter(v => v !== o.id))}
            style={{ border: 'none', background: 'transparent', cursor: 'pointer', display: 'inline-flex', padding: 0 }}
          >
            <Icon.Close c={BRAND} size={12} />
          </button>
        </span>
      ))}
      <select
        aria-label={ariaLabel}
        value=""
        disabled={available.length === 0}
        onChange={e => {
          const id = Number(e.target.value);
          if (id) onChange([...value, id]);
        }}
        style={{
          border: `1px solid ${t.border}`, borderRadius: 9, padding: '6px 10px', fontSize: 12,
          color: t.text, background: t.inputBg, fontFamily: 'Outfit, sans-serif', cursor: 'pointer',
        }}
      >
        <option value="">{placeholder}</option>
        {available.map(o => <option key={o.id} value={o.id}>{o.label}</option>)}
      </select>
    </div>
  );
}
